export default __webpack_public_path__ + "static/media/va.5b21bfb8.png";